// FintexProject.js
import React from 'react';

const ProjectInfo2 = () => (
    
    <div className="hsk-text">

    <p>
      <strong>Description:</strong><br />
      finteX Sim is a website that has a plethora of useful financial calculators.
    </p>

    <p> While there are no shortage of websites that offer the exact same thing, this one does it while providing a pleasent user experience with a modern looking UI and very responsive UX.</p>

    <p>This website is for young adults that want to have a better understanding of personal finance.</p>
    
    <p style={{ marginTop: '20px'}}>
    <strong>Features:</strong><br />
            - A personal networth calculator
    </p>
    <p>- Real Estate Investment ROI</p>
    <p>- Mortgage Payments Simulator</p>    
    <p>- Personal Networth Calculator</p>
    <p>- Savings Goal Timeline Calculator</p>
    </div>


);

export default ProjectInfo2;
